module.exports = __webpack_public_path__ + "img/OMN.720bdb4e.svg";